import { jsx as _jsx } from "react/jsx-runtime";
import { ModalCardWrapper } from './styles';
import { GRID_UNIT } from '../../utilities/grid';
import { Overlay } from '../Overlay';
export var ModalCard = function (_a) {
  var _b = _a.isVisible,
    isVisible = _b === void 0 ? true : _b,
    onClick = _a.onClick,
    hideBackdrop = _a.hideBackdrop,
    containerPosition = _a.containerPosition,
    _c = _a.padding,
    padding = _c === void 0 ? GRID_UNIT * 3 : _c,
    children = _a.children;
  return _jsx(Overlay, {
    isVisible: isVisible,
    onClick: onClick,
    hideBackdrop: hideBackdrop,
    containerPosition: containerPosition,
    children: _jsx(ModalCardWrapper, {
      padding: padding,
      "data-cy-label": "modal-card",
      children: children
    })
  });
};